// extracted by mini-css-extract-plugin
module.exports = {"socialIconButton":"SocialLinks_socialIconButton__KoQc9","socialIconButtonDark":"SocialLinks_socialIconButtonDark__q1kpQ","wrapper":"SocialLinks_wrapper__nBUjt"};